<template>
  <UserMenu v-if="authStore.user" class="hidden md:block">
    <UserProfile v-bind="{ isRuUser }" />
  </UserMenu>

  <UserProfile
    v-bind="{ isRuUser }"
    :class="{ 'md:hidden': authStore.user }"
    @click="onUserBtnClick"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { bus } from '/@shared/app'
import { UserProfile, UserMenu, useLocaleFeatures } from '/@app'
import { SUBDOMAIN_REDIRECTS } from '/@shared/constants'

import { useAuthStore } from '/@/stores'

const authStore = useAuthStore()

const route = useRoute()

const { isRuUser } = useLocaleFeatures()

const isAuthPage = computed(
  () => route.name === 'LoginPage' || route.name === 'SignupPage'
)

function onUserBtnClick() {
  if (authStore.user) bus.emit('app::show-mobile-account-menu')
  else {
    if (isRuUser.value && SUBDOMAIN_REDIRECTS) return
    if (authStore.profile === undefined) return

    if (!isAuthPage.value) bus.emit('app::show-login-aside')
  }
}
</script>
